export default __webpack_public_path__ + "static/media/7.b1d6d14d.jpg";